import { ReactNode } from 'react';
import { Link, useHref, useNavigate } from 'react-router';
import { IUiAiTransformRequest, UiProvider } from '@srm/ui/provider';
import { useTypedSelector } from '@hooks/useTypedSelector';
import { loadWorkCalendar } from '@utils/workCalendar';
import { controlPanelErrorsJournalUrl } from '@utils/controlPanelUrl';
import { canSeeDebugTools } from '@utils/debug/canSeeDebugTools';
import { AiService } from '@services/AiService';

const aiTransform = ({ key, text, signal }: IUiAiTransformRequest) =>
    AiService.transformTextareaValue(key, text, signal).then((response) => response.data);

/**
 * Возможности приложения для компонентов @srm/ui, которым нужны роутер и API: ссылки и переходы react-router,
 * рабочий календарь, AI-улучшение текста, ссылка «В журнал» у кода обращения (вне PROD — всем, на PROD — с правом
 * на админку). Стоит под BrowserRouter; уведомления наследует от AppMantineProvider —
 * тот выше роутера, потому что оборачивает и страницу ошибки.
 */
export const AppUiProvider = ({ children }: { children: ReactNode }) => {
    const navigate = useNavigate();
    const basename = useHref('/');
    const canViewAdminPanel = useTypedSelector((state) => !!state.auth.user?.canView?.adminPanel);
    return (
        <UiProvider
            linkComponent={Link}
            navigate={navigate}
            basename={basename}
            loadWorkCalendar={loadWorkCalendar}
            aiTransform={aiTransform}
            traceJournalHref={canSeeDebugTools(canViewAdminPanel) ? controlPanelErrorsJournalUrl : undefined}
        >
            {children}
        </UiProvider>
    );
};
